<template>
  <div v-loading="state.loading">
    <el-form labelPosition="top">
      <br>
      <el-form-item>
        <el-date-picker
          format="dd-MM-yyyy"
          v-model="dates[0]"
          placeholder="Начальная дата"
          @change="onDateChange"
        ></el-date-picker>-
        <el-date-picker
          format="dd-MM-yyyy"
          v-model="dates[1]"
          placeholder="Конечная дата"
          @change="onDateChange"
        ></el-date-picker>
      </el-form-item>
    </el-form>

    <div>
      <el-input v-model="state.filterText" placeholder="Поиск"></el-input>
      <br>
      <br>
      <div class="products-report__head__storages">
        <div
          class="products-report__tree__storages__item"
          v-for="storage in storages"
        >{{storage.name}}</div>
      </div>
      <el-tree
        :data="categoriesTree"
        v-if="categoriesTree.length"
        node-key="id"
        ref="tree"
        :filter-node-method="filterNode"
      >
        <div slot-scope="{node, data}" style="width: 100%;">
          <div>
            <div class="products-report__tree__name">
              <div v-if="!data.isProduct">{{data.name}}</div>
              <div v-if="data.isProduct">
                <router-link :to="{name: 'Goods.edit', params: {id: data.id}}">{{data.name}}</router-link>
              </div>
            </div>
          </div>

          <div class="products-report__tree__storages">
            <div class="products-report__tree__storages__item" v-for="storage in storages">
              <span v-if="data.storages && data.storages[storage.id]">
                <span
                  style="color: green;"
                >{{parseFloat(data.storages[storage.id].toStorage).toFixed(1)}}</span> |
                <span
                  style="color: red;"
                >{{parseFloat(data.storages[storage.id].fromStorage).toFixed(1)}}</span>
              </span>
            </div>
          </div>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
import {
  getReport,
  getCategories,
  getGoodsItem,
  getPlaces,
  getGoodStorages
} from "../../../api";
import { getProducts } from "@/modules/products/api";
import { loadProductsTree } from "@/api/global";
import { findIndex } from "lodash";
import { loadTree } from "../../../services/treeServices";
import { mapTree } from "@/utils/products";
import SGRTree from "@/modules/productsStorage/components/trees/storage_and_goods_report_tree";

export default {
  name: "storage_and_goods_report",
  data() {
    return {
      state: {
        loading: true,
        filterText: ""
      },
      dates: [
        this.$moment(new Date())
          .subtract(7, "days")
          .toDate(),
        new Date()
      ],
      categoriesList: [],
      categoriesTree: [],
      storages: [],
      reportItems: [],
      categoriesOfReportItems: [],
      places: [],
      defaultExpanded: []
    };
  },
  watch: {
    "state.filterText": {
      handler(val) {
        this.$refs.tree.filter(val);
      }
    }
  },
  created() {
    this.loadProductsTree();
  },
  methods: {
    async loadProductsTree() {
      if (!this.dates || !this.dates[0] || !this.dates[1]) {
        this.state.loading = false;
        return;
      }

      let reportParams = {
        date_start: this.dates[0],
        date_finish: this.$moment(this.dates[1])
          .add(1, "days")
          .toDate()
      };

      this.state.loading = true;
      Promise.all([
        loadProductsTree(),
        getReport(reportParams),
        getPlaces(),
        getGoodStorages(),
        getProducts({ "multysearch[status.statusId]": "1,2" })
      ]).then(response => {
        this.categories = response[0].data.items;
        this.products = response[4].data.items;
        this.storages = response[2].data.items;
        this.history = response[1].data.items
          ? response[1].data.items
          : response[1].data;

        this.mapStoragesToProducts(this.products);

        this.categoriesTree = mapTree(this.categories, this.products);

        this.categoriesTree.forEach(cat => {
          this.defaultExpanded.push(cat.id);
        });

        this.state.loading = false;
      });
    },
    mapStoragesToProducts(products) {
      products.forEach(product => {
        product.isProduct = true;
        product.storages = {};
        let historyItem = this.history.find(
          item => item.product.id === product.id
        );
        if (historyItem) {
          historyItem.storages.forEach(storage => {
            product.storages[storage.id] = { ...storage };
          });
        }
      });
    },
    async onDateChange() {
      this.loadProductsTree();
    },
    filterNode(value, data, node) {
      if (!value) return true;

      let includes =
        data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      return includes || this.checkNodeParent({ node, value });
    },
    checkNodeParent({ node, value }) {
      if (!node.parent || !node.parent.data.name) {
        return false;
      }

      let includes =
        node.parent.data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;

      if (node.parent.parent) {
        return includes || this.checkNodeParent({ node: node.parent, value });
      } else {
        return includes;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/storageAndGoods/tabs/report.vue